'use strict';
(() => {
  const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
  const root=JSON.parse($('#sf-routes').textContent).root;
  const picker=$('[data-active-flavor]');
  if(picker){
    let flavor='cherry-limeade',type='gummies';
    function select(){
      picker.dataset.activeFlavor=flavor;picker.dataset.activeType=type;
      $$('[data-flavor-item]').forEach(b=>{const on=b.dataset.flavorItem===flavor;b.dataset.active=String(on);b.setAttribute('aria-pressed',String(on));});
      $$('[data-flavor-type]').forEach(b=>{b.dataset.active=String(b.dataset.flavorType===type);b.setAttribute('aria-pressed',String(b.dataset.flavorType===type));});
      $$('[data-flavor-product]').forEach(p=>{const on=p.dataset.flavorProduct===flavor&&p.dataset.flavorProductType===type;p.classList.toggle('ada-show',on);p.inert=!on;p.setAttribute('aria-hidden',String(!on));});
      $$('[data-flavor-product-options]').forEach(p=>{
        const on=p.dataset.flavorProductOptions===flavor;p.classList.toggle('ada-show',on);p.inert=!on;p.setAttribute('aria-hidden',String(!on));
        p.querySelectorAll('a').forEach(a=>{const t=a.dataset.sourceHref.includes('gummies')?'gummies':'powder';a.hidden=t!==type;a.tabIndex=on&&t===type?0:-1;a.href=root+(t==='powder'&&flavor!=='watermelon'?'collections/all':'products/'+flavor+'-fiber-'+t);a.querySelector('span').textContent=t==='powder'&&flavor!=='watermelon'?'See available flavors':'Explore '+flavor.replaceAll('-',' ')+' '+t;});
      });
    }
    $$('[data-flavor-item]').forEach(b=>b.addEventListener('click',()=>{flavor=b.dataset.flavorItem;if(!['watermelon','cherry-limeade'].includes(flavor))type='powder';select();}));
    $$('[data-flavor-type]').forEach(b=>b.addEventListener('click',()=>{type=b.dataset.flavorType;select();}));select();
  }
  if(document.body.dataset.page==='gummies'){
    const flavor=location.pathname.includes('watermelon')?'watermelon':'cherry-limeade';
    const gallery=JSON.parse($('#sf-gummy-gallery').textContent)[flavor];
    $$('[data-sf-gummy-kind]').forEach(img=>{const url=gallery[img.dataset.sfGummyKind];if(url){img.src=url;img.removeAttribute('srcset');img.alt='Scoopfolk '+flavor.replaceAll('-',' ')+' gummies';}});
    $$('[data-gummy-decoration=lime],[data-gummy-decoration=cherry]').forEach(img=>img.hidden=flavor==='watermelon');
    const params=new URLSearchParams(location.search),form=$('.sf-product-form');
    if(form){
      const variant=params.get('variant'),select=form.querySelector('[data-variant-select]');
      if(variant&&[...select.options].some(o=>o.value===variant)){select.value=variant;select.dispatchEvent(new Event('change',{bubbles:true}));}
      const radios=[...form.querySelectorAll('[data-variant-panel]:not([hidden]) [name=selling_plan]')];
      const chosen=params.get('selling_plan'),oneTime=params.get('plan')==='one-time';
      const radio=chosen?radios.find(r=>r.value===chosen):oneTime?radios.find(r=>r.value===''):null;
      if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
      form.addEventListener('change',()=>{const radio=form.querySelector('[data-variant-panel]:not([hidden]) [name=selling_plan]:checked');const url=new URL(location.href);url.searchParams.set('variant',select.value);url.searchParams.set('plan',radio?.value?'subscription':'one-time');if(radio?.value)url.searchParams.set('selling_plan',radio.value);else url.searchParams.delete('selling_plan');history.replaceState(null,'',url);});
    }
  }
  $$('.js-video').forEach(w=>{const v=w.querySelector('video');if(v){v.addEventListener('play',()=>w.classList.add('is-playing'));v.addEventListener('pause',()=>w.classList.remove('is-playing'));}});
})();

// Repeat each marquee group far enough to cover wide screens before looping.
(() => {
  document.querySelectorAll('c-marquee').forEach(marquee => {
    const groups = [...marquee.querySelectorAll(':scope > .js-marquee-content')];
    if (!groups.length) return;
    const originals = [...groups[0].children].map(node => node.cloneNode(true));
    let lastWidth = 0;
    const fill = () => {
      const width = Math.ceil(marquee.clientWidth);
      if (!width || width === lastWidth) return;
      lastWidth = width;
      groups.forEach(group => {
        group.replaceChildren(...originals.map(node => node.cloneNode(true)));
        let repeats = 0;
        while (group.getBoundingClientRect().width < width && repeats++ < 20)
          group.append(...originals.map(node => node.cloneNode(true)));
      });
      if (groups.length === 1) {
        const copy = groups[0].cloneNode(true);
        copy.setAttribute('aria-hidden', 'true'); copy.inert = true;
        marquee.append(copy); groups.push(copy);
      }
      marquee.classList.add('sf-marquee-ready');
    };
    new ResizeObserver(fill).observe(marquee);
    document.fonts.ready.then(() => { lastWidth = 0; fill(); });
    fill();
  });
})();
